// The guided tour of Clearance & RDN Renewals, for HR and anybody else outside
// the Project Management Office who needs to see where a renewal has got to.
// Steps point at [data-tour] anchors on ClearanceRenewalsPage.

export const CLEARANCE_RENEWALS_TOUR_ID = 'clearance-renewals';

export const clearanceRenewalsTourSteps = [
  {
    title: 'Clearance & RDN Renewals',
    target: '[data-tour="page-header"]',
    body: [
      'Every security clearance, site pass and RDN renewal on one page. The daily expiry check raises an action on the Project Management Office for each one, and until now those actions could only be seen in the PMO\'s own My Actions.',
      'This page shows their progress and changes nothing: the PMO still work them in My Actions. Use Next to walk through, or Skip. Either way it will not pop up again; the ? by the title replays it.',
    ],
  },
  {
    title: 'The counts',
    target: '[data-tour="tiles"]',
    body: [
      'What is in flight, how many of those are overdue or not yet started, what expires in the next 90 days with no action raised yet, anything that lapsed with no action at all, and what was completed in the last 90 days. Click a count to see just those.',
    ],
  },
  {
    title: 'Four views',
    target: '[data-tour="tabs"]',
    body: [
      'In flight is every open renewal action: the expiry date, whether anybody on the PMO has started it, and the latest message on it.',
      'Coming up is every expiry date the check has not raised yet, with the day the PMO\'s action will open (the last day of the month six months before a clearance expires, three weeks before for a site pass or RDN), and any date that passed with nothing raised.',
      'Completed is every closed renewal: who marked it done or whether it closed on its own when a new date was recorded, and the date now on their record. A renewal marked done whose record still shows the old date is flagged.',
    ],
  },
  {
    title: 'The calendar',
    target: '[data-tour="tabs"]',
    body: [
      'Calendar puts every expiry on a month view, one chip per person and renewal, labelled with its status: overdue, not started, in progress, coming up, lapsed, done or closed by the record. Move between months with the arrows, and use +more on a busy day.',
    ],
  },
  {
    title: 'Narrowing it down',
    target: '[data-tour="filters"]',
    body: [
      'Show one kind of renewal, or search by name, role or team. The filters apply to every view, the calendar included.',
    ],
  },
  {
    title: 'The detail',
    target: '[data-tour="list"]',
    body: [
      'Click a row or a calendar chip to open its panel: who on the PMO it is on and who has started it, the full thread of messages, and how it was closed. If it is on you, Open in My Actions takes you to it.',
    ],
  },
];
